export default __webpack_public_path__ + "static/media/landing.cec3b244.mp4";